export default "__VITE_ASSET__f7161164__"